import React from 'react';
import { Avatar as Avatar$1 } from 'stream-chat-react';

const getImage = (member) => { var _a; return (_a = member.user) === null || _a === undefined ? undefined : _a.image; };
const Avatar = ({ member, size = 40 }) => React.createElement(Avatar$1, { image: getImage(member), shape: "square", size: size });
// based off of https://github.com/GetStream/website-react-examples/blob/master/social-messenger-ts/src/components/AvatarGroup/AvatarGroup.tsx
const AvatarGroup = ({ members, }) => {
    let content = null;
    if (members.length === 1) {
        content = React.createElement(Avatar, { member: members[0] });
    }
    if (members.length === 2) {
        content = (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(Avatar, { member: members[0] })),
            React.createElement("div", { style: { marginLeft: "-20px" } },
                React.createElement(Avatar, { member: members[1] }))));
    }
    if (members.length === 3) {
        content = (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(Avatar, { member: members[0] })),
            React.createElement("div", { style: { marginLeft: "-20px" } },
                React.createElement(Avatar, { member: members[1], size: 20 }),
                React.createElement(Avatar, { member: members[2], size: 20 }))));
    }
    if (members.length >= 4) {
        content = (React.createElement(React.Fragment, null,
            React.createElement("div", null,
                React.createElement(Avatar, { member: members[members.length - 4], size: 20 }),
                React.createElement(Avatar, { member: members[members.length - 3], size: 20 })),
            React.createElement("div", null,
                React.createElement(Avatar, { member: members[members.length - 2], size: 20 }),
                React.createElement(Avatar, { member: members[members.length - 1], size: 20 }))));
    }
    return React.createElement("div", { className: "str-chat__avatar-group" }, content);
};

export { AvatarGroup, AvatarGroup as default };
//# sourceMappingURL=avatar_group.js.map
